module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-auto-template/src/templates/asset-size-slider.html -->\n<button\n  class="square square-sm primary-border-hover"\n  data-nx-control="sliderMin"\n  title="'+
((__t=( i18n.t('i18n.minimumAssetSizeControl') ))==null?'':__t)+
'"\n></button>\n<input\n  type="range"\n  data-nx-control="slider"\n  title="'+
((__t=( i18n.t('i18n.assetSizeSliderControl') ))==null?'':__t)+
'"\n  min="70"\n  max="500"\n  step="10"\n  value="'+
((__t=( Netx.getPreference('assetList.thumbSize') ))==null?'':__t)+
'"\n  class="form-control"\n/>\n<button\n  class="square square-lg primary-border-hover"\n  data-nx-control="sliderMax"\n  title="'+
((__t=( i18n.t('i18n.maximumAssetSizeControl') ))==null?'':__t)+
'"\n></button>\n';
}
return __p;
};
